export const SET_SELECTED_PHOTOS = 'SET_SELECTED_PHOTOS';
export const SET_SELECTED_ROOMS = 'SET_SELECTED_ROOMS';
export const SET_MAIN_IMAGE = 'SET_MAIN_IMAGE';
